export default {
    state: {
        data: [],
        loadingData: false,
        dataDetail: [],
        loadingDataDetail: false,
        situations: [0, 0, 0, 0], // 0 = aberto, 1 = confirmado, 2 = cancelado, 3 = pendente de autorização
        loadingSituations: false,
        rejections: [],
        loadingRejections: false,
        snackBar: {
            visible: false,
            message: ''
        },
    },
    mutations: {
        setVendaRapidaNFCeData(state, payload) {
            state.data = []
            state.detail = []

            payload.forEach(element => {
                if (element) {
                    state.data.push({
                        ...element,
                        expanded: false
                    })
                }
            });
        },
        setVendaRapidaNFCeDataExpanded(state, payload) {
            state.data.forEach(element => {
                if (element == payload)
                    element.expanded = !element.expanded
            })
        },
        setVendaRapidaNFCeLoadingData(state, payload) {
            state.loadingData = payload
        },
        setVendaRapidaNFCeDataDetail(state, payload) {
            state.dataDetail.push(payload)
        },
        setVendaRapidaNFCeLoadingDataDetail(state, payload) {
            state.loadingDataDetail = payload
        },
        setVendaRapidaNFCeSituations(state, payload) {
            state.situations = [0, 0, 0, 0]

            const data = payload
            data.forEach(element => {
                state.situations[element.VENRNFCESITUACAO] = element.COUNT
            })
        },
        setVendaRapidaNFCeLoadingSituations(state, payload) {
            state.loadingSituations = payload
        },
        setVendaRapidaNFCeRejections(state, payload) {
            state.rejections = []

            payload.forEach(element => {
                if (element)
                    state.rejections.push({
                        ...element,
                        selected: true,
                    })
            })
        },
        setVendaRapidaNFCeToggleRejections(state, payload) {
            state.rejections.forEach(element => {
                if (element == payload)
                    element.selected = !element.selected
            })
        },
        setVendaRapidaNFCeLoadingRejections(state, payload) {
            state.loadingRejections = payload
        },
        setVendaRapidaNFCeSnackBar(state, payload) {
            state.snackBar.visible = payload.visible
            state.snackBar.message = payload.message
        },
    },
    actions: {
        setVendaRapidaNFCeData({ commit }, payload) {
            commit('setVendaRapidaNFCeData', payload)
        },
        setVendaRapidaNFCeDataExpanded({ commit }, payload) {
            commit('setVendaRapidaNFCeDataExpanded', payload)
        },
        setVendaRapidaNFCeLoadingData({ commit }, payload) {
            commit('setVendaRapidaNFCeLoadingData', payload)
        },
        setVendaRapidaNFCeDataDetail({ commit }, payload) {
            commit('setVendaRapidaNFCeDataDetail', payload)
        },
        setVendaRapidaNFCeLoadingDataDetail({ commit }, payload) {
            commit('setVendaRapidaNFCeLoadingDataDetail', payload)
        },
        setVendaRapidaNFCeSituations({ commit }, payload) {
            commit('setVendaRapidaNFCeSituations', payload)
        },
        setVendaRapidaNFCeLoadingSituations({ commit }, payload) {
            commit('setVendaRapidaNFCeLoadingSituations', payload)
        },
        setVendaRapidaNFCeRejections({ commit }, payload) {
            commit('setVendaRapidaNFCeRejections', payload)
        },
        setVendaRapidaNFCeToggleRejections({ commit }, payload) {
            commit('setVendaRapidaNFCeToggleRejections', payload)
        },
        setVendaRapidaNFCeLoadingRejections({ commit }, payload) {
            commit('setVendaRapidaNFCeLoadingRejections', payload)
        },
        setVendaRapidaNFCeSnackBar({ commit }, payload) {
            commit('setVendaRapidaNFCeSnackBar', payload)
        },
    }
}